// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"editCreate_formContainer__2sC0Y","form":"editCreate_form__dHIAS"};